import styled from "styled-components";

import VStack from "shared/components/layout/stack/VStack";

export const Container = styled(VStack)`
    text-align: left;
    padding: 0px;
    gap: 8px;
`;
